module.exports = __webpack_public_path__ + "static/media/home-bg-4.ee6baa41.jpg";